import { Injectable } from '@angular/core';

/**
 * Application configuration interface
 */
export interface AppConfig {
  apiUrl: string;
  production: boolean;
  features?: Record<string, boolean>;
}

/**
 * Configuration service for managing app-wide settings
 * Initialize this service with environment-specific config during app bootstrap
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig | null = null;

  /**
   * Initialize the configuration service
   * Call this in APP_INITIALIZER or during bootstrap
   */
  initialize(config: AppConfig): void {
    this.config = config;
  }

  /**
   * Get the full configuration object
   */
  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('ConfigService not initialized. Call initialize() first.');
    }
    return this.config;
  }

  /**
   * Get API base URL
   */
  get apiUrl(): string {
    return this.getConfig().apiUrl;
  }

  /**
   * Check if running in production mode
   */
  get isProduction(): boolean {
    return this.getConfig().production;
  }

  /**
   * Check if a feature flag is enabled
   */
  isFeatureEnabled(featureName: string): boolean {
    return this.getConfig().features?.[featureName] ?? false;
  }
}
